<template>
  <div class="container">
    <div class="video">
      <div
        v-loading="this.message"
        class="content"
        element-loading-spinner="el-icon-loading"
        :element-loading-text="message"
        @click="videoClick"
      >
        <div ref="videoRef" class="video" />
      </div>
      <!--      <img v-if="!isVideoPlay" v-loading="loading" src="../../static/play.png" @click="startVideo()">-->
      <!--      <img v-if="isVideoPlay" v-loading="loading" src="../../static/stop.png" @click="stopVideo()">-->
    </div>
  </div>
</template>

<script>
import DPlayer from 'dplayer'
import Flv from 'flv.js'
import videojs from 'video.js'
import 'videojs-flash'
import 'video.js/dist/video-js.min.css'
export default {
  name: 'VideoView',
  props: ['vKey', 'type', 'isMuted'],
  data() {
    return {
      videoId: null,
      loading: true,
      DetailData: null,
      playUrl: '123',
      hasAudio: true,
      timer: null,
      token: null,
      serverUrl: null,
      isLogin: false,
      message: null,
      muted: false
    }
  },
  mounted() {
    // var key = this.$route.query.key
    if (this.isMuted) {
      this.muted = true
    }
    this.videoId = 'video_' + this.vKey
    this.getAccesstoken()
    // this.loadDetailData(this.vKey)
  },
  beforeDestroy() {
    console.log('beforeDestroy')
    try {
      const videoDom = this.$refs.videoRef
      videojs(videoDom).dispose()
    } catch (e) {
      console.log(e)
    }

    this.DetailData = null
    this.rtmpUrl = null
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = null
  },
  methods: {
    async getAccesstoken() {
      this.message = '正在获取token'
      this.axios({
        headers: {
          orgId: sessionStorage.getItem('orgId')
        },
        method: 'get',
        url: process.env.API_ROOT + '/gateway/accesstoken?fixingid=' + this.vKey
      })
        .then(res => {
          res = res.data
          if (
            res &&
            res.successed &&
            res.result &&
            res.result.server_ip &&
            res.result.access_token
          ) {
            this.message = '正在登录视频服务'
            this.serverUrl = res.result.server_ip
            this.token = res.result.access_token
            this.initWebSocket()
          } else {
            this.message = 'token 获取失败'
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    initWebSocket() {
      // 初始化weosocket
      if (this.serverUrl) {
        this.websock = new WebSocket(this.serverUrl)
        this.websock.onmessage = this.websocketonmessage
        this.websock.onopen = this.websocketonopen
        this.websock.onerror = this.websocketonerror
        this.websock.onclose = this.websocketclose
      }
    },
    websocketonopen() {
      // 连接建立之后 直接登录
      const actions = { token: this.token }
      this.websocketsend('login ' + JSON.stringify(actions))
    },
    websocketonerror() {
      // 连接建立失败重连
      this.initWebSocket()
    },
    websocketonmessage(e) {
      // 数据接收
      if (e && e.data) {
        var command = e.data.substr(0, e.data.indexOf(' '))
        var content = e.data.substr(e.data.indexOf(' ') + 1, e.data.length)
        const rst = JSON.parse(content)
        if (command === 'Login') {
          // 登录返回
          if (rst.Successed) {
            this.message = '正在请求视频资源'
            this.isLogin = true
            this.sendVideoRequestCommand()
          } else {
            this.message = '视频服务登录失败'
          }
        } else if (command === 'Video') {
          // 视频请求返回
          if (rst.Successed && rst.Result.State === 2) {
            // 2播放
            this.playUrl = rst.Result.FlvUrl
            this.hasAudio = rst.Result.HasAudio
            this.playVideo()
          } else {
            this.playUrl = null
          }
        }
        console.log(command)
        console.log(JSON.parse(content))
      }
    },
    websocketsend(Data) {
      // 数据发送
      this.websock.send(Data)
    },
    websocketclose(e) {
      // 关闭
      console.log('断开连接', e)
    },
    sendVideoRequestCommand() {
      // 发送视频请求命令
      console.log('发送视频请求命令')
      var that = this
      this.timer = setInterval(function() {
        const actions = { fixingid: this.videoId, type: that.type }
        that.websocketsend('video ' + JSON.stringify(actions))
      }, 5000)
    },
    loadVideo: function() {
      console.log('loadVideo-customFlv', this.playUrl)
      var that = this
      this.player = new DPlayer({
        container: that.$refs.videoRef,
        live: true, // 是否直播
        autoplay: true, // 是否自动播放
        hotkey: false,
        mutex: false,
        lang: 'zh-cn', // 设置中文
        video: {
          url: that.playUrl,
          // type: "flv", //这一步必须要写，播放直播流
          type: 'customFlv',
          customType: {
            // customHls: function (video, player) {
            //     const hls = new Hls()
            //     hls.on(Hls.Events.ERROR, function (eventName, data) {
            //       // 埋点上报，可以追踪data.details
            //       // track()
            //       console.log("播放错误")
            //       that.player.destroy()
            //       that.player = null
            //     })
            //     hls.loadSource(video.src)
            //     hls.attachMedia(video)
            // }
            customFlv: function(video, player) {
              that.flvPlayer = Flv.createPlayer({
                type: 'flv',
                url: video.src,
                hasAudio: that.hasAudio
              })
              that.flvPlayer.attachMediaElement(video)
              that.flvPlayer.load()
            }
          }
        }
      })
      // this.player.play()

      if (this.player) {
        this.player.on('loadedmetadata', function() {
          // 埋点上报
          // track()
          console.log('loadedmetadata')
          that.message = null
          if (that.muted === true) {
            that.player.volume(0)
          }
        })
      }
    },
    playVideo: function() {
      if (!this.player) {
        this.loadVideo()
      }
    },
    startVideo: function() {
      console.log('startVideo')
      this.loading = true
      this.sendVideoRequestCommand()
    },
    stopVideo: function() {
      console.log('stopVideo')
      if (this.player) {
        this.player.pause()
        this.rtmpUrl = null
      }
      if (this.timer) {
        clearInterval(this.timer)
      }
    },
    videoClick: function() {}
  }
}
</script>
<style lang="css" rel="stylesheet/scss"  scoped>
.container {
  height: 100%;
  width: 100%;
}
.el-loading-mask {
  background-color: none;
}
.video {
  height: 100%;
  width: 100%;
}
.video .content {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}

.video img {
  width: 25px;
  height: 25px;
  cursor: pointer;
  margin-left: calc(50% - 12px);
  position: absolute;
  bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/video.vue